import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { PlayerProvider } from './context/PlayerContext';
import Layout from './components/Layout';
import Home from './pages/Home';
import Listen from './pages/Listen';
import Schedule from './pages/Schedule';
import Shows from './pages/Shows';
import About from './pages/About';
import Contact from './pages/Contact';
import Alexa from './pages/Alexa';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';

function App() {
  return (
    <PlayerProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/"          element={<Home />} />
            <Route path="/listen"    element={<Listen />} />
            <Route path="/schedule"  element={<Schedule />} />
            <Route path="/shows"     element={<Shows />} />
            <Route path="/about"     element={<About />} />
            <Route path="/contact"   element={<Contact />} />
            <Route path="/alexa"     element={<Alexa />} />
            <Route path="/privacy"   element={<Privacy />} />
            <Route path="/terms"     element={<Terms />} />
            <Route path="*"          element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </PlayerProvider>
  );
}

export default App;
